import React from 'react'

import { RxFileText } from 'react-icons/rx'
import { useNavigate } from 'react-router'

import { useProfessors } from '../../../context'
import { Profesor } from '../../../types'
import { capitalizeFirstLetter } from '../../../utilFunctions/transformFunc'
import {
  CardCouchDescription,
  CardCoachText,
  CoachBio,
  ImageCoach,
  CardContainerCoach,
  CoachTags,
  CardsCoachContainer,
} from '../styles'

const CardCoach = () => {
  const navigate = useNavigate()
  const { setActiveProfessor, professorsList } = useProfessors()
  const handleNavigation = (professor: Profesor) => {
    setActiveProfessor(professor)
    const name = `${professor.name.toLowerCase()}-${professor.lastname.toLowerCase()}`
    navigate(`/profesor/${name}`)
  }
  const isMobile = window.innerWidth < 768

  return (
    <CardsCoachContainer>
      {professorsList?.map((professor, i) => {
        return (
          <CardContainerCoach
            key={i}
            onClick={() => handleNavigation(professor)}
          >
            <div
              style={{
                display: 'flex',
                gap: '10px',
                flexDirection: 'column',
              }}
            >
              <ImageCoach
                style={{
                  backgroundImage: `url(${professor.image !== '' ? professor.image : '/assets/profile.png'})`,
                }}
              />
              <CoachBio style={{ display: isMobile ? 'flex' : 'none' }}>
                <RxFileText />
                <div className="bio-text">+Bio</div>
              </CoachBio>
            </div>

            <CardCouchDescription>
              <CardCoachText>
                <div className="title">
                  {professor.name} {professor.lastname}
                </div>
                <div className="subtitle">
                  <p>
                    {Array.isArray(professor.experienceType) &&
                      professor.experienceType
                        .sort((a, b) => {
                          const order = ['director de ah!', 'vocal coach']
                          const indexA = order.indexOf(a)
                          const indexB = order.indexOf(b)

                          if (indexA === -1 && indexB === -1) return 0
                          if (indexA === -1) return 1
                          if (indexB === -1) return -1
                          return indexA - indexB
                        })
                        .map((tag, i) => {
                          if (i < professor.experienceType.length - 1) {
                            return (
                              <span key={i}>
                                {' '}
                                {capitalizeFirstLetter(tag)} -{' '}
                              </span>
                            )
                          } else {
                            return (
                              <span key={i}>{capitalizeFirstLetter(tag)}</span>
                            )
                          }
                        })}
                  </p>
                </div>
              </CardCoachText>
              <CoachTags>
                {professor.activities.map((tag, i) => {
                  return (
                    <div className="tag" key={i}>
                      <p>{capitalizeFirstLetter(tag)}</p>
                    </div>
                  )
                })}
              </CoachTags>
              <CoachBio style={{ display: isMobile ? 'none' : 'flex' }}>
                <RxFileText />
                <div className="bio-text">+Bio</div>
              </CoachBio>
            </CardCouchDescription>
          </CardContainerCoach>
        )
      })}
    </CardsCoachContainer>
  )
}

export default CardCoach
